!function() {
  class e extends HTMLElement {
    constructor() {
      super(), this.observer = null, this.setupFooterBackgroundObserver();
    }
    disconnectedCallback() {
      this.observer && (this.observer.disconnect(), this.observer = null);
    }
    setupFooterBackgroundObserver() {
      const e = this.querySelector(".footer__background");
      if (!e) return;
      const t = window.matchMedia("(max-width: 1023px)"), r = () => {
        this.observer = new IntersectionObserver(t => {
          t.forEach(t => {
            t.isIntersecting ? e.style.setProperty("--overlay-opacity", "1") : e.style.setProperty("--overlay-opacity", "0");
          });
        }, {
          root: null,
          rootMargin: "0px 0px -100% 0px",
          threshold: 0
        }), this.observer.observe(this);
      }, s = () => {
        this.observer && (this.observer.disconnect(), this.observer = null), e.style.setProperty("--overlay-opacity", "0");
      };
      t.matches && r(), t.addEventListener("change", e => {
        e.matches ? r() : s();
      });
    }
  }
  customElements.get("site-footer") || customElements.define("site-footer", e);
}();